import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import Typography from '@rentspree/component-2023.components.atoms.typography'
import dayjs from 'dayjs'
import { forwardRef } from 'react'

import styles from './index.module.scss'

interface RentalDetailsProps {
  leasingInformation: LeasingInformation
  includedWithRent: string
}

const RentalDetails = forwardRef<HTMLDivElement, RentalDetailsProps>(
  ({ leasingInformation, includedWithRent }, ref) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { pricingDetails, leaseTerms, dateAvailable } = leasingInformation
    const { securityDeposit } = pricingDetails
    const { leaseType } = leaseTerms || {}

    return (
      <Box
        sx={{ paddingBottom: '40px', borderBottom: '1px solid #e0e0e0' }}
        id="rental-details"
        ref={ref}
      >
        <Typography variant="h3" fontSize={isMobile ? 24 : 32}>
          Rental details
        </Typography>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={6} md={6}>
            <Box className={styles.itemContainer}>
              <Typography variant="body-large" className={styles.itemTitle}>
                Security deposit
              </Typography>
              <Typography>
                ${securityDeposit || securityDeposit === 0 ? securityDeposit.toLocaleString() : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <Box className={styles.itemContainer}>
              <Typography variant="body-large" className={styles.itemTitle}>
                Lease type
              </Typography>
              <Typography>{leaseType || '-'}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={styles.itemContainer}>
              <Typography variant="body-large" className={styles.itemTitle}>
                Date available
              </Typography>
              <Typography>
                {dateAvailable ? dayjs(dateAvailable).format('MMMM D, YYYY') : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={styles.itemContainer}>
              <Typography variant="body-large" className={styles.itemTitle}>
                Included with rent
              </Typography>
              <Typography>{includedWithRent || '-'}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    )
  },
)

RentalDetails.displayName = 'RentalDetails'

export default RentalDetails
